export function getPlan(planName: string) {
    return planName.split(' ')[1];
  }